"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var analyticsCollector_exports = {};
__export(analyticsCollector_exports, {
  AnalyticsCollectorProvider: () => AnalyticsCollectorProvider
});
module.exports = __toCommonJS(analyticsCollector_exports);
var import_analytics_collector = require("@hcengineering/analytics-collector");
var import_platform = require("@hcengineering/platform");
var import_presentation = __toESM(require("@hcengineering/presentation"));
var import_utils = require("./utils");
class AnalyticsCollectorProvider {
  static {
    __name(this, "AnalyticsCollectorProvider");
  }
  collectIntervalMs = 5e3;
  maxRetries = 3;
  maxBatchSize = 100;
  maxBatchSizeBytes = 5 * 1024 * 1024;
  // 5MB
  events = [];
  collectTimer = null;
  url = "";
  email = void 0;
  anonymousId = "";
  isAuthenticated = false;
  data = null;
  init(config) {
    if (config.ANALYTICS_COLLECTOR_URL == null) return false;
    this.url = config.ANALYTICS_COLLECTOR_URL;
    if (this.url !== void 0 && this.url !== "" && this.url !== null) {
      this.initializeAnonymousId();
      this.startCollectionTimer();
      this.registerExceptionHandlers();
      return true;
    }
    return false;
  }
  initializeAnonymousId() {
    this.anonymousId = this.generateAnonymousId();
  }
  registerExceptionHandlers() {
    window.addEventListener("error", (event) => {
      this.handleError(event.error ?? new Error(event.message));
    });
    window.addEventListener("unhandledrejection", (event) => {
      this.handleError(event.reason instanceof Error ? event.reason : new Error(String(event.reason)));
    });
  }
  generateAnonymousId() {
    return "anon_" + Date.now() + "_" + Math.random().toString(36).substring(2, 15);
  }
  startCollectionTimer() {
    if (this.collectTimer != null) clearInterval(this.collectTimer);
    this.collectTimer = setInterval(() => {
      void this.sendEvents();
    }, this.collectIntervalMs);
  }
  stopCollectionTimer() {
    if (this.collectTimer != null) {
      clearInterval(this.collectTimer);
      this.collectTimer = null;
    }
  }
  async sendEvents() {
    if (this.events.length === 0) return;
    const token = (0, import_platform.getMetadata)(import_presentation.default.metadata.Token) ?? "";
    if (token === "") return;
    const batches = this.createBatches(this.events);
    this.events.length = 0;
    for (const batch of batches) {
      try {
        const response = await fetch(`${this.url}/collect`, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(batch)
        });
        if (!response.ok) {
          this.handleFailedEvents(batch);
        }
      } catch (err) {
        this.handleFailedEvents(batch);
      }
    }
  }
  createBatches(events) {
    const batches = [];
    let currentBatch = [];
    let currentBatchSize = 0;
    for (const event of events) {
      const eventSize = JSON.stringify(event).length;
      if (currentBatch.length >= this.maxBatchSize || currentBatchSize + eventSize > this.maxBatchSizeBytes && currentBatch.length > 0) {
        batches.push(currentBatch);
        currentBatch = [];
        currentBatchSize = 0;
      }
      currentBatch.push(event);
      currentBatchSize += eventSize;
    }
    if (currentBatch.length > 0) {
      batches.push(currentBatch);
    }
    return batches;
  }
  handleFailedEvents(failedEvents) {
    const eventsToRetry = [];
    failedEvents.forEach((event) => {
      event.retryCount = (event.retryCount ?? 0) + 1;
      if (event.retryCount <= this.maxRetries) {
        eventsToRetry.push(event);
      }
    });
    this.events.unshift(...eventsToRetry);
  }
  addEvent(eventType, properties = {}, eventName, overrideDistinctId) {
    const currentId = overrideDistinctId ?? (this.isAuthenticated && this.email != null ? this.email : this.anonymousId);
    const baseProperties = {
      ...properties,
      analytics_collector: true,
      $anonymous_id: this.anonymousId,
      $is_identified: this.isAuthenticated
    };
    let eventMetadata = {};
    try {
      eventMetadata = (0, import_utils.collectEventMetadata)(baseProperties);
    } catch (err) {
    }
    if (eventType === import_analytics_collector.AnalyticEventType.CustomEvent && (eventName !== "" || eventName != null)) {
      eventMetadata.event = eventName;
    }
    if (this.data != null) {
      for (const key in this.data) {
        if (Object.prototype.hasOwnProperty.call(this.data, key)) {
          const value = this.data[key];
          eventMetadata[key] = value;
        }
      }
    }
    const event = {
      event: eventType,
      properties: eventMetadata,
      timestamp: Date.now(),
      distinct_id: currentId
    };
    this.events.push(event);
  }
  normalizeUserData(data) {
    const cleanedData = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = data[key];
        if (Array.isArray(value)) {
          cleanedData[key] = value.join(", ");
        } else {
          cleanedData[key] = value;
        }
      }
    }
    return cleanedData;
  }
  setUser(email, data) {
    const wasAuthenticated = this.isAuthenticated;
    const previousId = this.anonymousId;
    const normalizedData = this.normalizeUserData(data);
    this.email = email;
    this.data = normalizedData;
    this.isAuthenticated = true;
    if (!wasAuthenticated && (previousId != null || previousId !== "")) {
      this.addEvent(
        import_analytics_collector.AnalyticEventType.SetAlias,
        {
          alias: previousId,
          distinct_id: email,
          previous_id: previousId,
          $anonymous_id: previousId
        },
        "$create_alias",
        previousId
      );
    }
    const setData = { email, ...normalizedData };
    this.addEvent(
      import_analytics_collector.AnalyticEventType.SetUser,
      {
        $set: setData,
        $set_once: {
          initial_url: window.location.pathname,
          first_seen: (/* @__PURE__ */ new Date()).toISOString()
        }
      },
      "$identify"
    );
  }
  setAlias(distinctId, alias) {
    this.addEvent(
      import_analytics_collector.AnalyticEventType.SetAlias,
      {
        alias,
        previous_id: distinctId
      },
      "$create_alias"
    );
  }
  setTag(key, value) {
    this.addEvent(
      import_analytics_collector.AnalyticEventType.SetTag,
      {
        $set: { [key]: value },
        $set_once: { initial_url: window.location.pathname }
      },
      "$set"
    );
  }
  setWorkspace(ws, guest) {
    const prop = guest ? "visited-workspace" : "workspace";
    this.addEvent(
      import_analytics_collector.AnalyticEventType.SetGroup,
      {
        $group_0: ws,
        $group_key: ws,
        $group_set: {
          name: ws,
          joined_at: (/* @__PURE__ */ new Date()).toISOString()
        },
        $group_type: prop,
        $groups: { [prop]: ws }
      },
      "$groupidentify"
    );
  }
  handleEvent(event, params) {
    this.addEvent(import_analytics_collector.AnalyticEventType.CustomEvent, { event, ...params }, event);
  }
  handleError(error) {
    const currentId = this.isAuthenticated && (this.email != null || this.email !== "") ? this.email : this.anonymousId;
    const event = {
      event: import_analytics_collector.AnalyticEventType.Error,
      properties: {
        error_message: error.message ?? "Unknown error",
        error_type: error.name ?? "Error",
        error_stack: error.stack ?? ""
      },
      timestamp: Date.now(),
      distinct_id: currentId ?? ""
    };
    this.events.push(event);
    void this.sendEvents();
  }
  navigate(path) {
    (0, import_utils.triggerUrlChange)();
    this.addEvent(import_analytics_collector.AnalyticEventType.Navigation, { path }, "$pageview");
  }
  logout() {
    void this.sendEvents();
    this.email = void 0;
    this.isAuthenticated = false;
    this.data = null;
    this.anonymousId = this.generateAnonymousId();
  }
  destroy() {
    this.stopCollectionTimer();
    void this.sendEvents();
  }
  flush() {
    return this.sendEvents();
  }
}
//# sourceMappingURL=analyticsCollector.js.map
